import { AuthContextProvider } from './context/AuthContext';
import { ToastProvider } from './components/ui';
import ErrorBoundary from './components/ErrorBoundary';
import AppRoutes from './routes';

export default function App() {
  return (
    <ErrorBoundary title="The Application Could Not Start">
      <ToastProvider>
        <AuthContextProvider>
          <AppRoutes />
        </AuthContextProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
}
